import Icon from '@components/icon/Icon';

import { MoveToCofeeStep, STEPPER_LABELS } from './constants';

const StepIndicator = ({
  stepIndex,
  currentStep
}: {
  stepIndex: number;
  currentStep: MoveToCofeeStep;
}) => {
  const isCompleted = stepIndex < currentStep;
  const isActive = stepIndex === currentStep;

  return (
    <div className="flex items-center gap-1">
      <div
        className={`flex size-8 items-center justify-center rounded-full font-medium ${
          isCompleted || isActive
            ? 'bg-cofeePrimary5 text-white'
            : 'bg-cofeeNeutral3 text-cofeeNeutral7'
        }`}
      >
        {isCompleted ? (
          <Icon
            name="check-mark"
            stroke="white"
            size="16"
            className="!min-w-0"
          />
        ) : (
          stepIndex + 1
        )}
      </div>
      <span
        className={`text-sm font-medium ${
          isActive ? 'text-primary' : 'text-cofeeNeutral7'
        }`}
      >
        {STEPPER_LABELS[stepIndex]}
      </span>
    </div>
  );
};

const StepperLine = ({ isCompleted }: { isCompleted: boolean }) => (
  <div
    className={`mx-1 h-0.5 w-17 ${
      isCompleted ? 'bg-cofeePrimary5' : 'bg-[#D9D9D9]'
    }`}
  />
);

interface StepperProps {
  currentStep: MoveToCofeeStep;
}

const Stepper = ({ currentStep }: StepperProps) => (
  <div className="sticky top-0 z-10 -mx-6 border-b border-cofeeNeutral4 bg-cofeeNeutral1 px-6 pb-5">
    <div className="flex items-center">
      {STEPPER_LABELS.map((_, index) => (
        <div key={STEPPER_LABELS[index]} className="flex items-center">
          {index > 0 && <StepperLine isCompleted={index <= currentStep} />}
          <StepIndicator stepIndex={index} currentStep={currentStep} />
        </div>
      ))}
    </div>
  </div>
);

export default Stepper;
